_ = require("lodash")

IndexEventCtrl = ($scope, $location, AnalysisEventService, goalSettings, $analytics, $routeParams, $filter, $translate) ->

  angular.element(document.body).css 'min-width', 0
  $analytics.eventTrack('ANL_loaded')

  if ($routeParams.user_id == undefined)
    $routeParams.user_id =  "me"

  createMyAnalysisParams = () ->
    from: $scope.startDate
    to: $scope.endDate

  callMyAnalysis = () ->
    params = createMyAnalysisParams()
    return if _.isEqual params, $scope.previousMyAnalysisParams
    $scope.previousMyAnalysisParams = params
    $scope.isLoadingDetailedAnalysisEvent = true
    AnalysisEventService.getMyAnalysis(params).then (myAnalysis) ->
      $scope.$broadcast "myAnalysisEventUpdated.gnp.analysis", myAnalysis
    .finally ->
      $scope.isLoadingDetailedAnalysisEvent = false
  $scope.goalSettings = goalSettings
  $scope.scorecards = []
  $scope.startDate = undefined
  $scope.endDate = undefined
  $scope.isShowDetailedAnalysisEvent = true
  $scope.isLoadingScoreCards = true
  $scope.isLoadingDetailedAnalysisEvent = true
  $scope.showNoResultMsg = false
  $scope.previousMyAnalysisParams = undefined
  $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG')
  $scope.tab = 1
  $scope.classTitle = "avg"

  $scope.gotoEventTab = ->
    url = "/group-event/"+ $routeParams.id + "/ranking"
    $location.url(url)
  $scope.activeDisplay = (tab) ->
    $scope.tab = tab
    if $scope.tab == 1
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL')
      $scope.classTitle = "goal"
    else if $scope.tab == 2
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG')
      $scope.classTitle = "avg"
    else if $scope.tab == 3
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE')
      $scope.classTitle = "best"
    else if $scope.tab == 4
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE')
      $scope.classTitle = "worst"
  $scope.eventData = false
  AnalysisEventService.getEvent().then (res) ->
    if res.status == 200
      $scope.eventData = res.data
  AnalysisEventService.getUserInfo().then (res) ->
    callMyAnalysis()
    if res.status == 200
      $scope.infoUser = res.data
  .finally ->
    $scope.isLoadingScoreCards = false
  # AnalysisEventService.getScoreCards().then (res) ->
  #   callMyAnalysis()
  #   $scope.scorecards = res.data.score_cards
  #   $scope.showNoResultMsg = $scope.scorecards.length is 0
  #   $scope.$emit "periodSelected.gnp.analysis", $scope.startDate, $scope.endDate
  # .finally ->
  #   $scope.isLoadingScoreCards = false

IndexEventCtrl.$inject = [
  '$scope'
  '$location'
  'AnalysisEventService'
  'goalSettings'
  '$analytics'
  '$routeParams'
  '$filter'
  '$translate'
]

module.exports = IndexEventCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/index-controller.coffee